import { useCallback, useState } from 'react';
import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { performGetRequest } from '@atlassian/jira-servicedesk-common/src/utils/fetch/requests.tsx';
import type { BaseUrl, ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type {
	OtherProjectWorkingHoursServiceState,
	WorkingHours,
} from '../../common/utils/calendars/types';
import { transformResponse, getUrl } from '../../common/utils/reusable-calendars/utils';

export const useWorkingHoursServiceOtherProjectCalendars = (
	baseUrl: BaseUrl,
	projectKey: ProjectKey,
): OtherProjectWorkingHoursServiceState => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [data, setData] = useState<unknown>();
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<unknown>(null);

	const fetch = useCallback(async () => {
		setLoading(true);
		setError(null);

		try {
			const response = await performGetRequest(getUrl(baseUrl, projectKey));
			const workingHours: WorkingHours = transformResponse(response);
			fireTrackAnalytics(createAnalyticsEvent({}), 'OtherProjectSlaCalendars viewed', {
				siteCalendarCount: workingHours.calendars.length,
			});
			setData(workingHours);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (err: any) {
			setError(err);
			trackFetchErrors({
				error: err,
				id: 'useWorkingHoursServiceOtherProjectCalendars',
				packageName: 'jiraServicedeskSlaSettings',
			});
		} finally {
			setLoading(false);
		}
	}, [baseUrl, createAnalyticsEvent, projectKey]);

	return [
		{
			loading,
			// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError | undefined'.
			error,
			// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'OtherProjectWorkingHoursServiceData'.
			data,
		},
		{
			fetch,
		},
	];
};
